import CheckIcon from "@heroicons/react/16/solid/CheckIcon";
import SparklesIcon from "@heroicons/react/24/outline/SparklesIcon";
import FilmIcon from "@heroicons/react/24/solid/FilmIcon";
import HeartIcon from "@heroicons/react/24/solid/HeartIcon";
import RectangleGroupIcon from "@heroicons/react/24/solid/RectangleGroupIcon";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import Color from "../../../assets/colors";
import { Grid } from "@mui/material";

export const SectionContainer = styling("div")({
  margin: "0 auto",
  maxWidth: "1440px",
  // padding: "5rem 6.25rem 3.75rem",

  "@media (max-width: 1280px)": {
    // padding: "2.5rem 1.5rem",
    padding: "0px",
  },

  "@media (max-width: 640px)": {
    //  padding: "2.5rem 1rem",
  },
});

export const ContactContainer = styling(Grid)({
  position: "sticky",
  bottom: "0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: "5px",
});

export const BoxContainer = styling(Box)({
  display: "flex",
  width: "100%",

  transition: "all 0.15s ease-in-out",
});

export const ColumnContainer = styling(Box)({
  display: "flex",
  flexDirection: "column",

  borderRadius: "0.625rem",
  overflow: "clip",

  maxWidth: "190px",
  width: "100%",
});

export const InnerColumnContainer = styling(Box)({
  display: "flex",
  alignItems: "center",
  borderBottom: "1px solid rgba(81, 42, 204, 0.10)",
  height: "58px",
  width: "100%",
});

export const RowContainer = styling(Box)({
  display: "flex",
  borderRadius: "0.625rem",
  overflow: "clip",
  transition: "all 0.15s ease-in-out",
});

export const TextStyled = styling(Typography)({});

export const GradientText = styling(Box)({});

export const PurpleStyled = styling("span")({
  color: Color.hiredlyPurple,
});

export const ButtonStyled = styling("button")({
  width: "auto",
  background: "none",
  border: "none",
  color: Color.hiredlyPurple,

  fontFamily: "Inter",
  fontSize: "1rem",
  fontWeight: 700,
  whiteSpace: "nowrap",

  padding: "0.6875rem 2rem",
  margin: "1rem auto 0",

  cursor: "pointer",

  "@media (min-width: 1280px)": {
    display: "inline-block",
    position: "relative",

    paddingBottom: "3px",

    "&:after": {
      content: '""',
      display: "block",
      margin: "auto",
      height: "2px",
      width: "0px",
      background: "transparent",
      transition: "width .25s ease, background-color .25s ease",
    },

    "&:hover:after": {
      width: "100%",
      background: Color.hiredlyPurple,
    },
  },

  "@media (max-width: 640px)": {
    padding: "0.5625rem 1rem",
    fontSize: "0.8rem",
  },
});

export const OutlineButtonStyled = styling("button")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  background: "none",
  border: `2px solid ${Color.black}`,
  borderRadius: "25rem",
  color: Color.black,

  width: "12.5rem",
  height: "2.625rem",

  fontFamily: "Inter",
  fontSize: "1rem",
  fontWeight: 700,

  cursor: "pointer",

  "@media (max-width: 640px)": {
    fontSize: "0.75rem",
    height: "1.875rem",
  },
});

export const ImageStyled = styling("img")({
  objectFit: "contain",
  height: "120px",
  width: "120px",
  margin: "0.5rem 0.75rem 0.875rem",

  "@media (max-width: 640px)": {
    height: "80px",
    width: "80px",
    margin: "0",
  },
});

export const CheckIconStyled = styling(CheckIcon)({
  height: "22px",
  width: "22px",
  color: Color.hiredlyPurple,
});

export const EmptyIconStyled = styling("div")({
  height: "26px",
  width: "26px",
});

export const TitleContainer = styling("div")({
  height: "164px",
  width: "440px",
});

export const TitleText = styling(Typography)({
  fontSize: "48px",
  fontWeight: "600",
  lineHeight: "52.8px",
  fontFamily: "Manrope",
});

export const TitleSpan = styling("span")({
  color: Color.hiredlyPurple,
});

export const GroupIconStyled = styling(RectangleGroupIcon)({
  height: "20px",
  width: "20px",
});

export const HeartIconStyled = styling(HeartIcon)({
  height: "20px",
  width: "20px",
});

export const FilmIconStyled = styling(FilmIcon)({
  height: "20px",
  width: "20px",
});

export const SparklesIconStyled = styling(SparklesIcon)({
  color: Color.hiredlyPurple,
  height: "16px",
  width: "16px",
});
